const FORM_STEP = 0;
const MODALITY_STEP = 1;
import { convertStringMoneyToNumber } from "@/utils/formats.js";
export const InsuranceCompanyMixin = {
  data: () => ({
    convertStringMoneyToNumber
  }),
  methods: {
    payloadInsuranceCompany(form, step, item = {}) {
      return {
        form: form,
        step: step,
        item: item
      };
    },
    getPayload(storeInsuranceCompany) {
      const payload = Object.assign(
        {},
        storeInsuranceCompany[FORM_STEP].form,
        storeInsuranceCompany[MODALITY_STEP].form
      );
      payload.modalidades.forEach(modalidade => {
        //Se for uma string, eu preciso converter parar número
        modalidade.valor_emissao_sem_ccg = this.convertStringMoneyToNumber(
          modalidade.valor_emissao_sem_ccg
        );
        modalidade.submodalidades.forEach(submodalidade => {
          submodalidade.valor_emissao_sem_ccg = this.convertStringMoneyToNumber(
            submodalidade.valor_emissao_sem_ccg
          );
        });
      });
      return payload;
    },
    saveRelationshipContact(payload, oldForm) {
      // Buscar o formulário que tenha a lista
      // dos contatos de relacionamento
      let form = this.itemSteps.find(x => x.step == this.steps.form).form
        .contatos_relacionamento;
      const index = form.indexOf(oldForm);
      const sameItems = form.find(
        x => x.nome == payload.form.nome && x.email == payload.form.email
      );
      // previne duplicidade de cadastro (nome e email iguals)
      // tanto para novos contatos ou edição
      if (
        (sameItems && index == -1) ||
        (sameItems && index > -1 && sameItems != form[index])
      ) {
        this.showAlertNotification({
          message: `Novo contato deve ter nome e email diferente dos atuais`,
          type: "error"
        });
        return;
      }
      // verifica se ele já existe na lista ou não
      if (index == -1) {
        form.push(payload.form);
      } else {
        form[index] = payload.form;
      }
      this.returnStep = false;
      this.currentStep = payload.step;
    }
  }
};
